import moment from 'moment';
import 'moment-timezone';

/**
 * formatMonthYear
 * Formats two ints for the month and year to a MM/YY string
 * @param  {number}   month   The month to format
 * @param  {number}   year    The year to format
 * @return {string}           The resulting formatted string
 */
export const formatMonthYear = (month, year) => {
  const stringifiedYear = year.toString();
  const formattedMonth = `${month > 9 ? '' : '0'}${month}`;
  const formattedYear = `${
    stringifiedYear.length > 2 ? stringifiedYear.substr(-2) : stringifiedYear
  }`;
  return `${formattedMonth}/${formattedYear}`;
};

/**
 * getFormattedDateFromTimezone
 * Formats a date/time in the user's timezone
 * @param  {string}   date    The date/time to format
 * @param  {string}   format  The format
 * @return {string}           The resulting formatted date/time
 */
export const getFormattedDateFromTimezone = (date, format) =>
  moment.tz(new Date(date), moment.tz.guess()).format(format);

/**
 * getDateDiff
 * Takes two moment objects and returns the difference in years, months, days,
 * hours, minutes and seconds between them
 * @param  {object} date1 a moment object with the date to make the difference from
 * @param  {object} date2 a moment object with the date to compare to the first
 * @return {object}       an object with the difference
 */
export const getDateDiff = (date1, date2) => {
  const years = date2.diff(date1, 'years');
  date2.add(-years, 'years');
  const months = date2.diff(date1, 'months');
  date2.add(-months, 'months');
  const days = date2.diff(date1, 'days');
  date2.add(-days, 'days');
  const hours = date2.diff(date1, 'hours');
  date2.add(-hours, 'hours');
  const minutes = date2.diff(date1, 'minutes');
  date2.add(-minutes, 'minutes');
  const seconds = date2.diff(date1, 'seconds');

  return {
    years,
    months,
    days,
    hours,
    minutes,
    seconds
  };
};

export const DAY_SECONDS = 24 * 60 * 60;
export const STANDARD_DATE_FORMAT = 'D MMM YYYY h:mm A z';
export const SIMPLE_DATE_FORMAT = 'D MMM YYYY';
export const SIMPLE_TIME_FORMAT = 'h:mm A z';
export const VERBOSE_DATE_FORMAT = 'DD MMM ’YY hh:mm A z';
export const CONDENSED_DATE_FORMAT = 'DD/MM';
